<template>
    <div id="questionnaireAdd" class="page">
        <div class="main-container">
            <div class="second-header-wrap">
                <el-button type="default" @click="$router.back()" size="medium">返回</el-button>
                <el-button @click.native="questionnairePublish(1)" type="primary" size="medium">保存</el-button>
                <el-button @click.native="questionnairePublish(2)" type="primary" size="medium">发布</el-button>
            </div>
            <div class="question-general-container">
                <div class="question-type-container">
                    <div class="question-type-container__title">常用类型</div>
                    <ul class="question-type">
                        <li @click="addQuestion('single-choice')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--single-choice"></span>
                            <span>单选题</span>
                        </li>
                        <li @click="addQuestion('multiple-choice')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--multiple-choice"></span>
                            <span>多选题</span>
                        </li>
                        <li @click="addQuestion('pic-single-choice')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--pic-single-choice"></span>
                            <span>图片单选题</span>
                        </li>
                        <li @click="addQuestion('pic-multiple-choice')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--pic-multiple-choice"></span>
                            <span>图片多选题</span>
                        </li>
                        <li @click="addQuestion('qna')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>问答题</span>
                        </li>
                        <li @click="addQuestion('fillblank')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>填空</span>
                        </li>
                        <li @click="addQuestion('singleChooseFill')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>单项填空</span>
                        </li>
                        <li @click="addQuestion('multipleChooseFill')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>多项填空</span>
                        </li>
                        <li @click="addQuestion('label')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>描述</span>
                        </li>
                        <li @click="addQuestion('divider')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>分割线</span>
                        </li>
                        <li @click="addQuestion('address')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>地址</span>
                        </li>
                        <li @click="addQuestion('pic-single-uploader')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>单个图片上传</span>
                        </li>
                        <li @click="addQuestion('pic-multiple-uploader')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>多个图片上传</span>
                        </li>
                        <li @click="addQuestion('rate')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>评分题</span>
                        </li>
                        <li @click="addQuestion('phone_num')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>手机号</span>
                        </li>
                        <li @click="addQuestion('email')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>邮箱</span>
                        </li>
                        <li @click="addQuestion('id_num')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>身份证</span>
                        </li>
                        <li @click="addQuestion('date')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>日期</span>
                        </li>
                        <li @click="addQuestion('time')" class="question-type-item">
                            <span class="question-type-item__icon question-type-item__icon--qna"></span>
                            <span>时间</span>
                        </li>
                    </ul>
                </div>
                <div class="questionnaire-container">
                    <div class="questionnaire-title">
                        <input type="text" v-model.trim="voteTitle" placeholder="模板标题"/>
                    </div>
                    <div class="question-container">
                        <template v-for="(questionItem, questionIndex) in topicList">
                            <!--单选-->
                            <div :key="questionIndex" v-if="questionItem.topType === 1"
                                 class="question-item quetion-item--single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                             class="question-option-container">
                                            <el-checkbox :true-label="1" :false-label="0" v-model="optionItem.isHaveReason">
                                                <input @focus.stop="focusInput(questionIndex, optionIndex)"
                                                       @blur.stop="blurInput"
                                                       v-model="optionItem.optionTitle"/>
                                                <i :class="['operation-icon', 'option-del-icon', currentFocusInput === `${questionIndex}-${optionIndex}` ? 'option-del-icon--show' : '']"
                                                   @click.stop.prevent="deleteOption(questionIndex, optionIndex)"></i>
                                            </el-checkbox>
                                        </div>
                                        <div class="question-choice-options">
                                            <i class="operation-icon add-choice-icon"
                                               @click="addChoiceHandler(questionItem)"></i>
                                            <i class="operation-icon batch-add-choice-icon"
                                               @click="batchAddClickHandler(questionItem)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--单选填空-->
                            <div :key="questionIndex" v-if="questionItem.topType === 14"
                                 class="question-item quetion-item--single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                             class="question-option-container">
                                            <el-checkbox :true-label="1" :false-label="0" v-model="optionItem.isHaveReason">
                                                <input @focus.stop="focusInput(questionIndex, optionIndex)"
                                                       @blur.stop="blurInput"
                                                       v-model="optionItem.optionTitle"/>
                                                <i :class="['operation-icon', 'option-del-icon', currentFocusInput === `${questionIndex}-${optionIndex}` ? 'option-del-icon--show' : '']"
                                                   @click.stop.prevent="deleteOption(questionIndex, optionIndex)"></i>
                                            </el-checkbox>
                                        </div>
                                        <div class="question-choice-options">
                                            <i class="operation-icon add-choice-icon"
                                               @click="addChoiceHandler(questionItem)"></i>
                                            <i class="operation-icon batch-add-choice-icon"
                                               @click="batchAddClickHandler(questionItem)"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--多选-->
                            <div :key="questionIndex" v-if="questionItem.topType === 2"
                                 class="question-item quetion-item--multiple-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                        限选
                                        <el-input-number size="small" :min="0"
                                                         v-model="questionItem.selectedMax"></el-input-number>
                                    </div>
                                    <div class="question-item__body">
                                        <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                             class="question-option-container">
                                            <el-checkbox :true-label="1" :false-label="0" v-model="optionItem.isHaveReason">
                                                <input @focus.stop="focusInput(questionIndex, optionIndex)"
                                                       @blur.stop="blurInput"
                                                       v-model="optionItem.optionTitle"/>
                                                <i :class="['operation-icon', 'option-del-icon', currentFocusInput === `${questionIndex}-${optionIndex}` ? 'option-del-icon--show' : '']"
                                                   @click.stop="deleteOption(questionIndex, optionIndex)"></i>
                                            </el-checkbox>
                                        </div>
                                        <div class="question-choice-options">
                                            <i class="operation-icon add-choice-icon"
                                               @click="addChoiceHandler(questionItem)"></i><i
                                            class="operation-icon batch-add-choice-icon"
                                            @click="batchAddClickHandler(questionItem)"></i></div>
                                    </div>
                                </div>
                            </div>

                            <!--多选填空-->
                            <div :key="questionIndex" v-if="questionItem.topType === 21"
                                 class="question-item quetion-item--single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                        限选
                                        <el-input-number size="small" :min="0"
                                                         v-model="questionItem.selectedMax"></el-input-number>
                                    </div>
                                    <div class="question-item__body">
                                        <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                             class="question-option-container">
                                            <el-checkbox :true-label="1" :false-label="0" v-model="optionItem.isHaveReason">
                                                <input @focus.stop="focusInput(questionIndex, optionIndex)"
                                                       @blur.stop="blurInput"
                                                       v-model="optionItem.optionTitle"/>
                                                <i :class="['operation-icon', 'option-del-icon', currentFocusInput === `${questionIndex}-${optionIndex}` ? 'option-del-icon--show' : '']"
                                                   @click.stop="deleteOption(questionIndex, optionIndex)"></i>
                                            </el-checkbox>
                                        </div>
                                        <div class="question-choice-options">
                                            <i class="operation-icon add-choice-icon"
                                               @click="addChoiceHandler(questionItem)"></i><i
                                            class="operation-icon batch-add-choice-icon"
                                            @click="batchAddClickHandler(questionItem)"></i></div>
                                    </div>
                                </div>
                            </div>

                            <!--图片单选-->
                            <div :key="questionIndex" v-if="questionItem.topType === 3"
                                 class="question-item quetion-item--pic-single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <div class="question-option-container"
                                             v-for="(optionItem, optionIndex) in questionItem.optionList">
                                            <div class="question-pic"
                                                 :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                            <div class="question-pic-desc">
                                            <span><el-checkbox :true-label="1" :false-label="0"
                                                               v-model="optionItem.isHaveReason">
                                                <input
                                                    @focus.stop="focusInput(questionIndex, optionIndex)"
                                                    @blur.stop="blurInput"
                                                    v-model="optionItem.optionTitle"
                                                />
                                            </el-checkbox></span>
                                                <i :class="['operation-icon', 'option-del-icon', currentFocusInput === `${questionIndex}-${optionIndex}` ? 'option-del-icon--show' : '']"
                                                   @click.stop="deleteOption(questionIndex, optionIndex)"></i>
                                            </div>
                                        </div>
                                        <uploader
                                            module="zhaoshengbaomingyoueryuan"
                                            pathPrefix="zhaoshengbaomingyoueryuan"
                                            moduleCode="20190308"
                                            v-model="questionItem.pics"
                                            :multiple="true"
                                            :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                            showMode="image"
                                            showResult="no"
                                            :successCallback="optionPicUploadSuccessHandler(questionIndex)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>
                            <!--图片多选-->
                            <div :key="questionIndex" v-if="questionItem.topType === 4"
                                 class="question-item quetion-item--pic-multiple-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                        限选
                                        <el-input-number size="small" :min="0"
                                                         v-model="questionItem.selectedMax"></el-input-number>
                                    </div>
                                    <div class="question-item__body">
                                        <div class="question-option-container"
                                             v-for="(optionItem, optionIndex) in questionItem.optionList">
                                            <div class="question-pic"
                                                 :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                            <div class="question-pic-desc">
                                            <span><el-checkbox :true-label="1" :false-label="0"
                                                               v-model="optionItem.isHaveReason">
                                                <input
                                                    @focus.stop="focusInput(questionIndex, optionIndex)"
                                                    @blur.stop="blurInput"
                                                    v-model="optionItem.optionTitle"
                                                />
                                            </el-checkbox></span>
                                                <i :class="['operation-icon', 'option-del-icon', currentFocusInput === `${questionIndex}-${optionIndex}` ? 'option-del-icon--show' : '']"
                                                   @click.stop="deleteOption(questionIndex, optionIndex)"></i>
                                            </div>
                                        </div>
                                        <uploader
                                            module="zhaoshengbaomingyoueryuan"
                                            pathPrefix="zhaoshengbaomingyoueryuan"
                                            moduleCode="20190308"
                                            v-model="questionItem.pics"
                                            :multiple="true"
                                            :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                            showMode="image"
                                            showResult="no"
                                            :successCallback="optionPicUploadSuccessHandler(questionIndex)"
                                        >
                                        </uploader>
                                    </div>
                                </div>
                            </div>

                            <!--问答题-->
                            <div :key="questionIndex" v-if="questionItem.topType === 5"
                                 class="question-item quetion-item--qna">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            placeholder=""
                                            :value="''">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <!--填空题-->
                            <div :key="questionIndex" v-if="questionItem.topType === 6"
                                 class="question-item quetion-item--fill-blank">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input
                                            type="textarea"
                                            :rows="3"
                                            placeholder="填空题(空处用{n}表示)"
                                            v-model="questionItem.topicTitle"
                                        >
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                            <!--描述-->
                            <div :key="questionIndex" v-if="questionItem.topType === 7"
                                 class="question-item quetion-item--fill-blank">
                                <div class="question-item__left">
                                    <el-tag type="primary">描述</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__body">
                                        <el-input type="text" v-model="questionItem.topicTitle">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <!--分割线-->
                            <div :key="questionIndex" v-if="questionItem.topType === 8"
                                 class="question-item quetion-item--divider">
                                <div class="question-item__left">
                                    <ul class="question-operation">
                                        <el-tag type="primary">分割</el-tag>
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="divider"></div>
                                </div>
                            </div>
                            <!--地址-->
                            <div :key="questionIndex" v-if="questionItem.topType === 9"
                                 class="question-item quetion-item--address">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                </div>
                            </div>

                            <!--单个图片上传-->
                            <div :key="questionIndex" v-if="questionItem.topType === 10"
                                 class="question-item quetion-item--pic-single-uploader">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-upload
                                            class="logo-uploader"
                                            :disabled="true"
                                        >
                                            <div class="upload-hint"></div>
                                        </el-upload>
                                    </div>
                                </div>
                            </div>

                            <!--多个图片上传-->
                            <div :key="questionIndex" v-if="questionItem.topType === 11"
                                 class="question-item quetion-item--pic-multiple-uploader">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-upload
                                            class="logo-uploader"
                                            :disabled="true"
                                        >
                                            <div class="upload-hint"></div>
                                        </el-upload>
                                    </div>
                                </div>
                            </div>

                            <!--评分题-->
                            <div :key="questionIndex" v-if="questionItem.topType === 12"
                                 class="question-item quetion-item--multiple-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>
                                    </div>
                                    <div class="question-item__body">
                                        <el-rate ></el-rate>
                                    </div>
                                </div>
                            </div>

                            <!--手机号-->
                            <div :key="questionIndex" v-if="questionItem.topType === 15"
                                 class="question-item quetion-item--pic-single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input type="text" :value="''">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <!--邮箱-->
                            <div :key="questionIndex" v-if="questionItem.topType === 16"
                                 class="question-item quetion-item--pic-single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input type="text" :value="''">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <!--身份证-->
                            <div :key="questionIndex" v-if="questionItem.topType === 17"
                                 class="question-item quetion-item--pic-single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input type="text" :value="''">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <!--日期-->
                            <div :key="questionIndex" v-if="questionItem.topType === 18"
                                 class="question-item quetion-item--pic-single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input type="text" :value="''">
                                        </el-input>
                                    </div>
                                </div>
                            </div>

                            <!--时间-->
                            <div :key="questionIndex" v-if="questionItem.topType === 19"
                                 class="question-item quetion-item--pic-single-choice">
                                <div class="question-item__left">
                                    <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                                    <ul class="question-operation">
                                        <li v-if="questionIndex !== 0">
                                            <el-tooltip class="item" effect="dark" content="上移本题" placement="left">
                                                <i @click="changeQuestionPosition('up', questionIndex)"
                                                   class="operation-icon up-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li v-if="questionIndex !== topicList.length - 1">
                                            <el-tooltip class="item" effect="dark" content="下移本题" placement="left">
                                                <i @click="changeQuestionPosition('down', questionIndex)"
                                                   class="operation-icon down-icon"></i>
                                            </el-tooltip>
                                        </li>
                                        <li>
                                            <el-tooltip class="item" effect="dark" content="删除本题" placement="left">
                                                <i @click="deleteQuestion(questionIndex)"
                                                   class="operation-icon question-delete-icon"></i>
                                            </el-tooltip>
                                        </li>
                                    </ul>
                                </div>
                                <div class="question-item__right">
                                    <div class="question-item__title">
                                        <input v-model="questionItem.topicTitle"/>
                                        <el-checkbox v-model="questionItem.isHaveToDo" :true-label="0" :false-label="1">必做</el-checkbox>&nbsp;&nbsp;
                                    </div>
                                    <div class="question-item__body">
                                        <el-input type="text" :value="''">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal='false' title="批量添加" :visible.sync="isDialogShow" @close="batchAddQuestionContent = ' '">
            <div style="margin-bottom: 10px;">每行代表一个选项，可以添加多个选项</div>
            <el-input
                type="textarea"
                :rows="3"
                :maxlength="500"
                v-model="batchAddQuestionContent"
            >
            </el-input>
            <div class="dialog-button-container">
                <el-button size="medium" type="primary" :loading="loading.replay" @click="confirmClickHandler">添加</el-button>
                <el-button size="medium" type="default" :loading="loading.replay" @click="cancelClickHandler">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Uploader from '@/components/Uploader/WebUploader';
    import moment from 'moment';
    import AddressBook from '@/components/AddressBook/indexExpand';
    import {addVoteTwo, sendViewVoteTwo, getVoteTwoById} from '@/api/setting';

    export default {
        name: "TemplateAdd",
        components: {
            AddressBook,
            Uploader
        },
        data: function () {
            return {
                currentFocusInput: null,
                voteTitle: '',
                topicList: [],
                basePath: global.BasePath,
                loading: {
                    replay: false
                },
                questionItemList: [],
                isDialogShow: false,
                batchAddQuestionContent: '',
                batchAddCurrentQuestion: null,
                id: this.$route.query.id
            }
        },
        created() {
            if(this.id) {
                getVoteTwoById({
                    voteId: this.id
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        pageData.topicList.forEach(item => {
                            if (item.topType === 4 || item.topType === 3) {
                                item.picList = item.optionList.map(item => ({src: item.optionPicUrl}));
                            }
                        });
                        this.voteTitle = pageData.voteTitle;
                        this.voteDesc = pageData.voteDesc;
                        this.sendUserType = pageData.sendUserType;
                        this.expriyDate = pageData.expriyDate;
                        this.anonymous = pageData.anonymous;
                        this.topicList = pageData.topicList;
                        this.stuDepartJson = pageData.stuDepartJson;
                        this.stuDepart = JSON.parse(pageData.stuDepartJson);
                        this.thScopeJson = pageData.thScopeJson;
                        this.thScope = JSON.parse(pageData.thScopeJson);
                        this.voteStatus = pageData.voteStatus;
                        this.isShowResult = pageData.isShowResult;
                        this.maxVoteCount = pageData.maxVoteCount;

                        if(pageData.sendUserType === 1) {
                            const thScope = JSON.parse(pageData.thScopeJson);

                            this.teacherAddressData = {
                                userJson: [],
                                departJson: [],
                                groupJson: []
                            };
                        } else {
                            this.studentAddressData = {
                                userJson: [],
                                departJson: [],
                                groupJson: []
                            }
                        }
                    });
            }
        },
        computed: {
            ...mapGetters(['currentSchoolYear'])
        },
        methods: {
            resetTopicSeq() {
                let seq = 0;
                this.topicList.forEach(topicItem => {
                    if(topicItem.topType !== 7 && topicItem.topType !== 8) {
                        seq ++;
                        topicItem.topicSeq = seq;
                    } else {
                        topicItem.topicSeq = 0;
                    }
                });
            },
            batchAddClickHandler(questionItem) {
                this.batchAddCurrentQuestion = questionItem;
                this.isDialogShow = true;
            },
            addChoiceHandler(questionItem) {
                questionItem.optionList.push({
                    isHaveReason: 0,
                    optionPicUrl: '',
                    optionSeq: questionItem.optionList.length + 1,
                    optionTitle: questionItem.topType === 14 || questionItem.topType === 21 ? '选项标题(空处用{n}表示)' : '选项标题'
                });
            },
            focusInput(questionIndex, optionIndex) {
                setTimeout(() => {
                    this.currentFocusInput = `${questionIndex}-${optionIndex}`;
                }, 250);
            },
            blurInput() {
                setTimeout(() => {
                    this.currentFocusInput = null;
                }, 200);
            },
            questionnairePublish(voteStatus) {
                if(this.voteTitle === '') {
                    this.$message.error('请填写模板标题！');
                } else if(this.topicList.length === 0) {
                    this.$message.error('问卷至少包含一个问题！');
                } else {
                    let validFlag = true;
                    const fillblankRegexp = /{\d+?}/;
                    this.topicList.forEach(topicItem => {
                        if(topicItem.topicTitle === '' && topicItem.topType !== 8) {
                            this.$message.error('问题标题不能为空！');
                            validFlag = false;
                        } else if([1, 2, 3, 4, 14, 21].indexOf(topicItem.topType) !== -1) {
                            if(topicItem.optionList.length === 0) {
                                this.$message.error('问题至少包含一个选项！');
                                validFlag = false;
                            } else if(topicItem.optionList.some(optionItem => optionItem.optionTitle === '')) {
                                this.$message.error('选项描述不能为空！');
                                validFlag = false;
                            } else if(topicItem.topType === 21 || topicItem.topType === 14) {
                            }
                        } else if(topicItem.topType === 6 && !fillblankRegexp.test(topicItem.topicTitle)) {
                            this.$message.error('填空题格式不正确！');
                            validFlag = false;
                        }
                        return validFlag;
                    });
                    if(validFlag) {
                        const formData = {
                            anonymous: 2,
                            expriyDate: moment().format('YYYY-MM-DD'),
                            isShowResult: 1,
                            maxVoteCount: 0,
                            sendUserType: 2,
                            stuDepartJson: {},
                            thScopeJson: {},
                            topicList: this.topicList,
                            voteDesc: '',
                            voteStatus,
                            voteTitle: this.voteTitle,
                            voteType: 1
                        };

                        if(voteStatus === 0) {
                            sendViewVoteTwo(formData, this.currentSchoolYear)
                                .then(res => res.data)
                                .then(data => {
                                    if (data.result) {
                                        const _this = this;
                                        this.$message({
                                            message: '发送预览成功，请在手机上查看',
                                            type: 'success',
                                            duration: 1000
                                        });
                                    }
                                });
                        } else {
                            this.$confirm(`是否确认${voteStatus === 1 ? '保存' : '发布'}?`, `${voteStatus === 1 ? '保存' : '发布'}`, {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                addVoteTwo(formData, this.currentSchoolYear)
                                    .then(res => res.data)
                                    .then(data => {
                                        if(data.result) {
                                            const _this = this;
                                            this.$message({
                                                message: voteStatus === 1 ? '保存成功！' : '发布成功！',
                                                type: 'success',
                                                duration: 1000,
                                                onClose: function () {
                                                    _this.$router.back();
                                                }
                                            });
                                        }
                                    });
                            }).catch(() => {
                            });
                        }

                    }
                }
            },
            optionPicUploadSuccessHandler(questionIndex) {
                return (data) => {
                    this.topicList[questionIndex].optionList.push({
                        sHaveReason: 0,
                        optionPicUrl: data.fileUrl,
                        optionSeq: this.topicList[questionIndex].optionList.length + 1,
                        optionTitle: '选项标题'
                    });
                }
            },
            deleteOption(questionIndex, optionIndex) {
                this.topicList[questionIndex].optionList =
                    [
                        ...this.topicList[questionIndex].optionList.slice(0, optionIndex),
                        ...this.topicList[questionIndex].optionList.slice(optionIndex + 1)
                    ];
            },
            confirmClickHandler() {
                const options = this.batchAddQuestionContent.split('\n');
                const optionList = [];
                options
                    .filter(item => item.trim() !== '')
                    .forEach((item, index) => {
                        optionList.push({
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: this.batchAddCurrentQuestion.optionList.length + index,
                            optionTitle: item
                        });
                    });
                this.batchAddCurrentQuestion.optionList = [...this.batchAddCurrentQuestion.optionList, ...optionList];
                this.batchAddCurrentQuestion = null;
                this.batchAddQuestionContent = '';
                this.isDialogShow = false;
            },
            cancelClickHandler() {
                this.batchAddCurrentQuestion = null;
                this.batchAddQuestionContent = '';
                this.isDialogShow = false;
            },
            resetTopicOrder() {
                this.topicList.forEach((topicItem, index) => {
                    topicItem.topicOrder = index + 1;
                });
            },
            deleteQuestion(questionIndex) {
                this.topicList = [
                    ...this.topicList.slice(0, questionIndex),
                    ...this.topicList.slice(questionIndex + 1)
                ];
                this.resetTopicOrder();
                this.resetTopicSeq();
            },
            changeQuestionPosition(type, questionIndex) {
                if (type === 'up') {
                    this.topicList = [
                        ...this.topicList.slice(0, questionIndex - 1),
                        this.topicList[questionIndex],
                        this.topicList[questionIndex - 1],
                        ...this.topicList.slice(questionIndex + 1)
                    ];
                } else {
                    this.topicList = [
                        ...this.topicList.slice(0, questionIndex),
                        this.topicList[questionIndex + 1],
                        this.topicList[questionIndex],
                        ...this.topicList.slice(questionIndex + 2)
                    ];
                }
                this.resetTopicSeq();
                this.resetTopicOrder();
            },
            addQuestion(questionType) {
                const topicOrder = this.topicList.length + 1;
                let topicSeq = this.topicList.length - this.topicList.filter(item => item.topType === 7 || item.topType === 8).length + 1;
                let optionList = [],
                    selectedMax = 0,
                    topType = 0,
                    topicTitle = '',
                    isHaveToDo = 0;
                switch (questionType) {
                    case 'singleChooseFill':
                        selectedMax = 0;
                        topType = 14;
                        topicTitle = '单项填空';
                        optionList = [{
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 1,
                            optionTitle: '选项标题(空处用{n}表示)',
                        }, {
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 2,
                            optionTitle: '选项标题(空处用{n}表示)',
                        }];
                        break;
                    case 'multipleChooseFill':
                        selectedMax = 0;
                        topType = 21;
                        topicTitle = '多项填空';
                        optionList = [{
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 1,
                            optionTitle: '选项标题(空处用{n}表示)',
                        }, {
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 2,
                            optionTitle: '选项标题(空处用{n}表示)',
                        }];
                        break;
                    case 'single-choice':
                        selectedMax = 0;
                        topType = 1;
                        topicTitle = '文字单选';
                        optionList = [{
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 1,
                            optionTitle: '选项标题',
                        }, {
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 2,
                            optionTitle: '选项标题',
                        }];
                        break;
                    case 'multiple-choice':
                        selectedMax = 0;
                        topType = 2;
                        topicTitle = '文字多选';
                        optionList = [{
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 1,
                            optionTitle: '选项标题',
                        }, {
                            isHaveReason: 0,
                            optionPicUrl: '',
                            optionSeq: 2,
                            optionTitle: '选项标题',
                        }];
                        break;
                    case 'pic-single-choice':
                        selectedMax = 0;
                        topType = 3;
                        topicTitle = '图片单选';
                        optionList = [];
                        break;
                    case 'pic-multiple-choice':
                        selectedMax = 0;
                        topType = 4;
                        topicTitle = '图片多选';
                        optionList = [];
                        break;
                    case 'qna':
                        selectedMax = 0;
                        topType = 5;
                        topicTitle = '问答题';
                        optionList = [];
                        break;
                    case 'fillblank':
                        selectedMax = 0;
                        topType = 6;
                        topicTitle = '';
                        optionList = [];
                        break;
                    case 'label':
                        selectedMax = 0;
                        topType = 7;
                        topicTitle = '描述';
                        optionList = [];
                        topicSeq = 0;
                        isHaveToDo = 1;
                        break;
                    case 'divider':
                        selectedMax = 0;
                        topType = 8;
                        topicTitle = '分割线';
                        optionList = [];
                        topicSeq = 0;
                        isHaveToDo = 1;
                        break;
                    case 'address':
                        selectedMax = 0;
                        topType = 9;
                        topicTitle = '地址';
                        optionList = [];
                        break;
                    case 'pic-single-uploader':
                        selectedMax = 0;
                        topType = 10;
                        topicTitle = '单个图片上传';
                        optionList = [];
                        break;
                    case 'pic-multiple-uploader':
                        selectedMax = 0;
                        topType = 11;
                        topicTitle = '多个图片上传';
                        optionList = [];
                        break;
                    case 'rate':
                        selectedMax = 0;
                        topType = 12;
                        topicTitle = '评分题';
                        optionList = [];
                        break;
                    case 'phone_num':
                        selectedMax = 0;
                        topType = 15;
                        topicTitle = '手机号';
                        optionList = [];
                        break;
                    case 'email':
                        selectedMax = 0;
                        topType = 16;
                        topicTitle = '邮箱';
                        optionList = [];
                        break;
                    case 'id_num':
                        selectedMax = 0;
                        topType = 17;
                        topicTitle = '身份证';
                        optionList = [];
                        break;
                    case 'date':
                        selectedMax = 0;
                        topType = 18;
                        topicTitle = '日期';
                        optionList = [];
                        break;
                    case 'time':
                        selectedMax = 0;
                        topType = 19;
                        topicTitle = '时间';
                        optionList = [];
                        break;
                }
                this.topicList.push({
                    isHaveToDo,
                    optionList,
                    selectedMax,
                    topType,
                    topicOrder,
                    topicSeq,
                    topicTitle,
                    pics: []
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    @include globalstyle;

    .second-header-wrap {
        width: 92%;
        min-width: 1200px;
        height: 60px;
        line-height: 60px;
        padding: 5px 4%;
        background-color: #fff;
    }
    .question-general-container {
        width: 92%;
        min-width: 1200px;
        padding: 5px 4%;
        background-color: #fff;
        @include clearfix;
    }
    .page {
        padding: 0;
    }

    .main-container {
    }

    .question-type-container {
        width: 14%;
        @include clearfix;
        float: left;
        border: 1px solid #DBDBDB;

        .question-type-container__title {
            width: 100%;
            height: 35px;
            line-height: 35px;
            text-align: center;
            cursor: pointer;
            background-color: #fff;
            border-bottom: 1px solid #eee;
            font-size: 16px;
            font-weight: bold;
        }

        .question-type {
            margin: 0;
            box-sizing: border-box;

            .question-type-item {
                margin: 10px 0;
                cursor: pointer;

                & > * {
                    @include middleIB;
                }

                &:hover {
                    color: #000;

                    .question-type-item__icon {
                        background-image: url(../../../assets/images/wjsj_toolico.png);
                    }
                }

                .question-type-item__icon {
                    background-image: url(../../../assets/images/wjsj_toolico_off.png);
                    width: 20px;
                    height: 20px;
                    margin-left: 10px;
                    margin-right: 4px;

                    &.question-type-item__icon--single-choice {
                        background-position: 0 -119px;
                    }

                    &.question-type-item__icon--multiple-choice {
                        background-position: 0 -140px;
                    }

                    &.question-type-item__icon--pic-single-choice {
                        background-position: 0 -630px;
                    }

                    &.question-type-item__icon--pic-multiple-choice {
                        background-position: 0 -630px;
                    }

                    &.question-type-item__icon--qna {
                        background-position: 0 -377px;
                    }
                }
            }
        }

    }

    .questionnaire-container {
        border: 1px solid #DBDBDB;
        width: 85%;
        float: right;
        box-sizing: border-box;

        input[type=text], textarea {
            &:focus {
                background: #FDF9CD;
            }
        }

        .questionnaire-title, .questionnaire-desc, .questionnaire-setting {
            padding: 5px 50px;

            input, textarea {
                width: 100%;
                height: 100%;
                text-align: center;
                font-size: 20px;
                border: 0;
                resize: none;
            }
        }

        .address-book-container {
            width: 200px;
            display: inline-block;
            vertical-align: middle;
        }

        .questionnaire-title {
            height: 56px;
            text-align: center;
        }

        .questionnaire-desc {
            height: 90px;
            border-top: 1px solid #DBDBDB;

            textarea {
                font-size: 18px;
            }
        }

        .operation-icon {
            display: none;
            /*display: inline-block;*/
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background-image: url(../../../assets/images/wjsj_toolico_off.png);
            background-repeat: no-repeat;
            cursor: pointer;
        }

        .question-container {
            padding: 5px 0;

            .question-item__body {
                margin-top: 10px;
            }

            .question-item {
                @include clearfix;
                padding: 10px 0;
                border-top: 1px solid #DBDBDB;

                &:hover {
                    .add-choice-icon, .batch-add-choice-icon, .up-icon, .down-icon, .question-delete-icon {
                        display: inline-block;
                    }
                }

                .question-item__left {
                    text-align: center;
                    width: 50px;
                    float: left;

                    .question-operation {
                        margin: 10px 0;

                        li {
                            margin-bottom: 5px;
                            display: block;
                            text-align: center;

                            &:last-child {
                                margin: 0;
                            }

                            .operation-icon {
                                &:hover {
                                    background-image: url(../../../assets/images/wjsj_toolico.png);
                                }
                            }

                            .up-icon {
                                background-position: -23px -513px;
                            }

                            .down-icon {
                                background-position: -23px -538px;
                            }

                            .question-delete-icon {
                                background-position: -21px -180px;
                            }
                        }

                    }
                }

                .question-item__right {
                    float: left;
                    width: 80%;
                    box-sizing: border-box;
                    padding: 0 10px;

                    .question-item__title {
                        font-size: 14px;

                        input {
                            width: 72%;
                        }
                    }

                    .question-choice-options {
                        height: 26px;
                    }

                    input, textarea {
                        width: 100%;
                        height: 100%;
                        font-size: 14px;
                        border: 0;
                        resize: none;
                        margin-bottom: 5px;

                        &:focus {
                            background: #FDF9CD;
                        }
                    }

                    .option-del-icon {
                        margin-left: 5px;
                        background-position: -122px -241px;

                        &.option-del-icon--show {
                            display: inline-block !important;
                        }
                    }

                    .add-choice-icon {
                        margin-left: 20px;
                        background-position: -20px -200px;
                    }

                    .batch-add-choice-icon {
                        margin-left: 10px;
                        background-position: -20px -220px;
                    }

                }
            }

        }

        .quetion-item--pic-single-choice,
        .quetion-item--pic-multiple-choice,
        .quetion-item--pic-single-uploader,
        .quetion-item--pic-multiple-uploader {
            .question-option-container {
                box-sizing: border-box;
                width: 160px;
                height: 190px;
                float: left;
                border: 1px solid #ccc;
                margin-right: 10px;
                margin-bottom: 10px;
                padding: 5px;

                .question-pic {
                    width: 150px;
                    height: 150px;
                    display: block;
                    margin-bottom: 5px;
                    @include cover-bg;
                }

                .question-pic-desc {
                    span {
                        @include middleIB;
                        width: 80%;
                    }

                    input {
                        width: 80% !important;
                    }
                }
            }

            .upload-hint {
                width: 160px;
                height: 190px;
                float: left;
                border: 1px solid #ccc;
                margin-right: 10px;
                margin-bottom: 10px;
                background: url(../../../assets/images/picinput.png) no-repeat;
                background-position: center center;
                cursor: pointer;
            }
        }
    }

    .dialog-button-container {
        margin-top: 10px;
        text-align: right;
    }

    .divider {
        border: 1px solid #999;
    }

</style>
<style lang="scss">
    #questionnaireAdd {
        .address-box-item {
            line-height: 36px;
        }
        .search-input {
            width: 100%;
            margin: 0;
        }
        .img-upload {
            width: 80px;
            height: 80px;
            float: left;
            border: 1px solid #ccc;
            margin-right: 10px;
            margin-bottom: 10px;
            background: url(../../../assets/images/picinput.png) no-repeat center center;
            cursor: pointer;
            box-sizing: border-box;

        }
    }
</style>



// WEBPACK FOOTER //
// src/views/kindergarten/setting/TemplateAdd.vue